import type { TimelineRailRoundMarker } from '../../lib/timelineRailMarkers'
import { TIMELINE_COL_TIME } from './timelineGrid'

type Props = {
  marker: TimelineRailRoundMarker
  angular: boolean
}

/** 轨左侧：仅展示时刻（HH:mm），顶与节点、内容对齐 */
export function TimelineRailDateColumn({ marker, angular }: Props) {
  const { labels, showTime } = marker
  const { title, timeLabel } = labels

  if (!showTime || !timeLabel.trim()) {
    return (
      <div className={[TIMELINE_COL_TIME, 'w-[2.35rem] shrink-0 sm:w-[2.65rem]'].join(' ')} aria-hidden />
    )
  }

  return (
    <div
      className={[
        TIMELINE_COL_TIME,
        'flex w-[2.35rem] shrink-0 flex-col items-end self-start bg-surface pt-0.5 sm:w-[2.65rem]',
        angular ? '' : 'pt-px',
      ].join(' ')}
      title={title}
    >
      <span
        className={[
          'glyphicai-timeline-time max-w-full truncate text-right font-semibold tabular-nums leading-none text-ink',
          angular ? 'text-xs tracking-tight' : 'text-[13px] tracking-tight sm:text-sm',
        ].join(' ')}
      >
        {timeLabel}
      </span>
    </div>
  )
}
